import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import TablePaginationActions from "./TablePaginationActions";
import Paper from "@material-ui/core/es/Paper";
import Table from "@material-ui/core/es/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/es/TableRow";
import TableCell from "@material-ui/core/es/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/es/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import Grow from "@material-ui/core/es/Grow";

class DeviceInfoList extends Component {

    state = {
        page: 0,
        rowsPerPage: 5,
    };

    handleChangePage = (event, page) => this.setState({page});

    handleChangeRowsPerPage = event => this.setState({rowsPerPage: event.target.value});

    render() {
        const {classes, account, timeout} = this.props;
        const {rowsPerPage, page} = this.state;
        const {userInfo} = account.pii;
        if (!userInfo || (userInfo && userInfo.filter(user => user.phone).length === 0)) {
            return null
        }
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, userInfo.length - page * rowsPerPage);

        return (
            <Grow in timeout={timeout || 1000}>
                <Paper className={classes.pageContainer}>
                    <h2 className={classes.title}>User Info</h2>
                    <div className={classes.tableWrapper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Phone Numbers</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userInfo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    return (
                                        <TableRow key={n.phone}>
                                            <TableCell>{n.phone}</TableCell>
                                        </TableRow>
                                    );
                                })}
                                {/*{emptyRows > 0 && (*/}
                                    {/*<TableRow style={{height: 48 * emptyRows}}>*/}
                                        {/*<TableCell colSpan={6}/>*/}
                                    {/*</TableRow>*/}
                                {/*)}*/}
                            </TableBody>
                            {userInfo.length > 5 &&
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        colSpan={5}
                                        count={userInfo.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        rowsPerPageOptions={[5]}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        Actions={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>}
                        </Table>
                    </div>
                </Paper>
            </Grow>
        );
    }
}

function mapStateToProps({account}) {
    return ({account})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceInfoList);



// WEBPACK FOOTER //
// ./src/containers/delete-account/components/UserInfoTable.js